module.exports = __webpack_public_path__ + "img/3-技能.7ee733ad.gif";